import React from "react";
import Image from "react-bootstrap/Image";

const PosterPreview = ({ poster, onClick }) => {
  return (
    <div className="poster-preview" onClick={onClick}>
      <Image
        className="gallery-image-preview"
        thumbnail
        onClick={onClick}
        src={
          poster.pages.filter(
            (x) => x.indexOf("mp3") === -1 && x.indexOf("mp4") === -1
          )[0]
        }
      />
      <p>
        <b>{poster.title}</b>
      </p>
      <p>{poster.authors}</p>
      {poster.contactDetails.facebook && (
        <div className="contact-details-item">{`Afiliacja: ${poster.contactDetails.facebook}`}</div>
      )}
    </div>
  );
};

export default PosterPreview;
